import { render, staticRenderFns } from "./TestMaster.vue?vue&type=template&id=07f8e85f"
import script from "./TestMaster.vue?vue&type=script&lang=js"
export * from "./TestMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports